// import { canUseDOM } from 'exenv';

export function giftGuidePageLoading(resp = {}, store = {}) {
  return {
    type: 'GIFT_GUIDE_PAGE_LOADING',
    giftGuidePage: resp,
    store
  };
}

export function giftGuidePageLoaded(resp = {}, store = {}) {
  return {
    type: 'GIFT_GUIDE_PAGE_LOADED',
    giftGuidePage: resp,
    store
  };
}

export function giftGuidePageLoadError(error, store = {}) {
  return {
    type: 'GIFT_GUIDE_PAGE_ERROR',
    giftGuidePage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
